import React from 'react'
import { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import CreatableSelect from 'react-select/creatable'
export default function Language(props) {
  const { handleActiveChange, active, modeUrl } = props
  // React state to manage selected options
  const [optionList, setSelectedOptions] = useState([
    { value: 'Telugu', label: 'Telugu' },
    { value: 'English', label: 'English' },
    { value: 'Hindi', label: 'Hindi' },
  ])
  const optionste = [
    { value: 'తెలుగు', label: 'తెలుగు' },
    { value: 'ఆంగ్ల', label: 'ఆంగ్ల' },
    { value: 'హిందీ', label: 'హిందీ' },
  ]
  // Array of all options
  // styles =++++++++++++++++++++++>
  const styles = {
    control: base => ({
      ...base,
      // borderColor: state.isFocused ? 'yellow' : 'green',
      borderColor:
        (props.editData.language.length === props.language.length &&
          isSame(props.editData.language, props.language)) ||
        props.active.language === 'TRUE'
          ? 'green'
          : 'red',
    }),
  }
  // console.log(styles, 'language styles')
  const isSame = (a, b) => a.value === b.value && a.label === b.label
  // Function triggered on selection
  function handleSelect(data) {
    const optionList1 = [...optionList]
    // console.log(data)
    /* setSelectedOptions(data) */
    const issame = (data, optionList1) =>
      data.value === optionList1.value && data.label === optionList1.label
    const onlyInLeft = (left, right, compareFunction) =>
      left.filter(leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)))
    const onlydata = onlyInLeft(data, optionList1, issame)
    optionList1.push(...onlydata)
    setSelectedOptions(optionList1)
    // props.sendlanguage('language', data)
    // console.log(optionList)
    const languagearrayindex = []
    const languagete = []
    data.forEach(element =>
      optionList1.forEach((e, index) => {
        if (e.value === element.value) {
          languagearrayindex.push(index)
        }
      }),
    )
    languagearrayindex.forEach(e => {
      if (optionste[e] !== undefined) {
        languagete.push(optionste[e])
      }
    })
    const inputData = { ...props.inputData }
    inputData.language = data
    inputData.languagete = languagete
    // console.log(inputData, 'inputdta=========================----')
    props.sendBooleanValueChangeDone('language', true)
    props.sendinputdata(inputData)
    // props.sendlanguage('inputFieldslanguage', data)
    // console.log(languagete)
  }

  return (
    <div className='app'>
      <Row>
        <Col md={6} xs={12}>
          <div style={{ display: 'flex' }}>
            <div>
              <div>
                <label>Language_En:</label>
              </div>
              <div className='dropdown-container'>
                <CreatableSelect
                  options={optionList}
                  placeholder='Select language'
                  value={props.language}
                  onChange={handleSelect}
                  isSearchable={true}
                  isMulti
                  styles={modeUrl && styles}
                />
              </div>
              {props.language.length < 1 && (
                <span className='mandatory1'>language should not be empty</span>
              )}
            </div>
          </div>
        </Col>
        {props.inputData.languagete.length >= 1 && (
          <Col md={6} xs={12}>
            <div>
              <label>Language_Te:</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid lightgray' }}>
              {props.inputData.languagete.map((e, index) => (
                <span
                  style={{
                    margin: '5px',
                    border: '1px solid black',
                    padding: '1px',
                    borderRadius: '1rem',
                  }}
                  key={index}
                >
                  {e.value}
                </span>
              ))}
            </div>
          </Col>
        )}
      </Row>
      {modeUrl ? (
        <div>
          <div className='tinput'>
            <div
              className='currentlyactive-style'
              style={{ display: 'flex', gap: '10px', position: 'relative' }}
            >
              <input
                id='c12'
                type='checkbox'
                name='currently active'
                checked={active.language === 'TRUE'}
                onChange={event => handleActiveChange(event, 'language')}
              />
              <label htmlFor='c12'>OK</label>
              <br></br>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
